import { apiService } from './apiService';

export interface TaskNotificationItem {
  id: string;
  title: string;
  message: string;
  isRead: boolean;
  createdAt: string;
}

const mapItem = (item: any): TaskNotificationItem => ({
  id: String(item.id),
  title: item.title || '',
  message: item.message || '',
  isRead: Boolean(item.isRead),
  createdAt: item.createdAt || new Date().toISOString(),
});

export const taskNotificationApiService = {
  async getMyNotifications(): Promise<TaskNotificationItem[]> {
    const response = await apiService.get('/TaskNotifications/me');
    const data = Array.isArray(response?.data) ? response.data : [];
    return data.map(mapItem);
  },

  async markAllAsRead(): Promise<void> {
    await apiService.patch('/TaskNotifications/me/read-all');
  },
};
